import { reduxForm } from 'redux-form';

import AdditionalForm from "./AdditionalForm";
import ContactForm from "./ContactForm";
import validate from './validate';

export const Type = {
    name: 'Additional Products',
    form: reduxForm({
        form: 'AdditionalWizard',
        destroyOnUnmount: false,
        // forceUnregisterOnUnmount: true,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(AdditionalForm)
};

export const Contact = {
    name: 'Contact',
    form: ContactForm
};


// WEBPACK FOOTER //
// ./src/containers/AdditionalForm/index.js